import { useEffect, useState } from "react";
import api from "../lib/api";

/**
 * Fetches the current launch-promo state from /api/public/promo.
 * Returns { state, loading } where state can be null until first load,
 * or { active, slots_remaining, slots_total, end_date_iso, discount_pct,
 *       duration_months, label, code }.
 */
export function usePromo() {
  const [state, setState] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    let mounted = true;
    api
      .get("/promo")
      .then(({ data }) => mounted && setState(data))
      .catch(() => mounted && setState(null))
      .finally(() => mounted && setLoading(false));
    return () => {
      mounted = false;
    };
  }, []);
  return { state, loading };
}

/**
 * Returns a discounted price string (1 decimal, FR format).
 * E.g. discountedPrice(49, 20) -> "39,2"
 */
export function discountedPrice(base, pct) {
  const n = Number(base) * (1 - Number(pct) / 100);
  return n.toLocaleString("fr-FR", { minimumFractionDigits: 1, maximumFractionDigits: 2 });
}
